const base = {
  'c.HeadTooBar.slogan': 'Premium parts, One-Stop Global Sourcing',
  'c.HeadTooBar.modifyPassword': 'Modify Password',
  'c.HeadTooBar.logout': 'Logout',
  'c.HeadTooBar.signUp': 'Sign up',
  'c.HeadTooBar.login': 'Login',
  'c.HeadTooBar.helpCenter': 'HelpCenter',

  'base.button.login': 'Login',
  'base.button.ok': 'OK',
  'base.message.pleaseLogin': 'Please login to access',

  'base.language': 'Language',
  'base.countryorregion': 'Country/Region',
  'base.currency': 'Currency',
  'base.currency.placeholder': 'Please select currency',

  'base.noData': 'No data',
  'base.OE': 'OE',

  'menu.home': 'Home',
  'menu.product': 'Part Catalog',
  copyright:
    'Copyright © 2015 - Present CassTime. All rights reserved. Shenzhen CassTime Technology Co., Ltd.',

  'home.vehicleBrandTitle': '{vehicleBrand} Highlights of Accessories Introduction',
  'home.AccessoriesClassification': 'Accessories classification',
  'home.comingSoon': 'Coming soon',

  'productList.total': 'We have found {total} results for you.',
  'productList.priceTips':
    '*The displayed price is EXW,actual prices may vary with order quantity.',
  'productList.loginToView': 'Login to view',
  'productList.circulationRating': 'Circulation Rating',
  'productList.contactUs': 'Contact Us',
  'productList.addToList': 'Add to list',
  'productList.removeList': 'Remove list',
  'productList.filter.oe.placeholder': 'Part OE number or name',
  'productList.contactUs.web': 'Contact Us Web',
  'productList.contactUs.template': 'Hello, I would like to learn more about this product: ',
  'productList.applicableVehicleTypes': 'Applicable vehicle types',
  'productList.approximately': 'approximately',

  'pagination.total': 'Total {total} items',

  'base.message.apiError': 'System is busy! Please try again later.',

  'base.remark': 'Remarks',
  'base.remark.placeholder': 'Please enter remarks',
  'base.remark.maxLength': 'Remarks cannot exceed {total} characters',

  'base.copy': 'Copy',
  'base.copied': 'Copied',

  'page.title.addressList': 'Address Management',
  'page.title.orderList': 'Order Management',
  'page.title.orderDetails': 'Order Details',
  'page.title.orderConfirmation': 'Order Confirmation',

  'base.noLogin.getInfoError':
    'Failed to retrieve user information. Please refresh the page and try again.',
  'base.api.error': 'System is busy! Please try again later.',

  'base.creator': 'Creator',
  'base.createdDate': 'Created Date',
  'base.operation': 'Operation',
  'base.detail': 'Details',

  'base.attachment': 'Attachment',
  'base.form.checkForm': 'Please check the form content',
  'base.index': 'Index',
  'base.status': 'Status',
  'base.quantity': 'Quantity',

  'base.HeadTooBar.getUserInfoFailed':
    'Failed to retrieve user information. Please refresh the page and try again.',
  Search: 'Search',
  Action: 'Action',
  Delivery: 'Delivery',
  total_days: '{total} days',
  Item: 'Item',
  Price_currency: 'Price ({currency})',

  total_Parts: '{total} Parts',
  total_parts: '{total} parts',
  Show_all: 'Show all',
  Collapse: 'Collapse',
  Part_name: 'Part name',
  Brand: 'Brand',
  Part_number: 'Part number',
  Description: 'Description',
  loading: 'loading...',
};
export default base;
